export function getHistorySessionIndex () {
    return sessionStorage.getItem('is_historySessionIndex') ? parseInt(sessionStorage.getItem('is_historySessionIndex'), 10) : 0
}

export function cleanHistory () {
    let i = sessionStorage.length
    while (i--) {
        let key = sessionStorage.key(i)
        if (key.indexOf('is_') !== -1) {
            sessionStorage.removeItem(key)
        }
    }
    sessionStorage.setItem('is_historySessionIndex', 0)
}

export function cleanPath (url) {
    if (url !== '/' && url[url.length-1] === '/') {
        return url.slice(-1);
    }
    else {
        return url
    }
}

export function addHistoryHit () {
    const url = window.location

    let index = getHistorySessionIndex()
    let lastHit = sessionStorage.getItem(`is_historySession_${index}`)

    // Clean the sessionStorage with historySessions if the current page is the home page
    if (url.pathname === '/') {
        cleanHistory()
        index = 0
    }

    // Add an hit if the history is empty
    if ((url.pathname + url.search !== lastHit || index === 0) && url.pathname !== '/login') {
        const newIndex = index + 1
        sessionStorage.setItem(`is_historySession_${newIndex}`, cleanPath(url.pathname + url.search))
        sessionStorage.setItem('is_historySessionIndex', newIndex)
    }
}

export function checkHistory () {
    const url = window.location
    let maxIndex = getHistorySessionIndex()
    let index = -1

    // Clean the sessionStorage with historySessions if the current page is the home page
    if (url.pathname === '/') {
        cleanHistory()
        index = 0
    }

    if (getHistorySessionIndex() === 0 || (getHistorySessionIndex() === 1 && sessionStorage.getItem(`is_historySession_${1}`) === '/')) {
        addHistoryHit()
    } else {
        for (let i = 1; i <= maxIndex; i++) {
            if (cleanPath(url.pathname + url.search) === cleanPath(sessionStorage.getItem(`is_historySession_${i}`))) {
                index = i
                sessionStorage.setItem('is_historySessionIndex', index)
            }
            if (index !== -1 && i > index) {
                sessionStorage.removeItem(`is_historySession_${i}`)
            }
        }
    }
}

export function updateLastHit () {
    const url = window.location
    let index = getHistorySessionIndex()
    let lastHit = sessionStorage.getItem(`is_historySession_${index}`)

    // Check if the history is empty
    if (index === 0) {
        addHistoryHit(cleanPath(url.pathname + url.search))
    } else if (url.pathname + url.search!== lastHit) {
        sessionStorage.setItem(`is_historySession_${index}`, cleanPath(url.pathname + url.search))
    }
}

export function popPreviousHit () {
    // Removing the current page history record
    let index = getHistorySessionIndex()
    sessionStorage.removeItem(`is_historySession_${index}`)
  
    // Update index with the previous history record
    const newIndex = index - 1
    sessionStorage.setItem('is_historySessionIndex', newIndex)
  
    return getLastHit()
  }

export function getLastHit () {
    let index = getHistorySessionIndex()

    let last = '/'
    if (index > 0) {
        last = cleanPath(sessionStorage.getItem(`is_historySession_${index}`))
    }
    
    // Get the last page history record
    return last
}
